module.exports = __webpack_public_path__ + "static/media/doctor-avatar-2.53c71cd0.svg";